var map = {
	"./THV PENCEGAHAN - Copy (2).jpg": 43535,
	"./THV PENCEGAHAN - Copy (3).jpg": 1041,
	"./THV PENCEGAHAN - Copy.jpg": 94864,
	"./THV PENCEGAHAN.jpg": 83266,
	"./dummy.txt": 12647
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 74242;